import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import React from 'react';
import theme from '../theme';
import ButtonComp from './Button';

type ConfirmDeletePopupProps = {
  open: boolean;
  onClose: () => void;
  confirmDelete:()=>void;
};

export default function ConfirmDeletePopup(props:ConfirmDeletePopupProps) {
    const {
    open,
    onClose, 
    confirmDelete
  } = props;
  const label = "Are you sure you want to delete?"
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="otp-dialog-title"
      aria-describedby="otp-dialog-description"
      slotProps={{
        paper: {
          sx: {
            // Responsive pass (F.9): the fixed 500x350 overflowed a 390px
            // handheld viewport. Desktop keeps its exact size at sm and up;
            // below that the dialog fits the viewport and grows to its
            // content instead of clipping it.
            width: { xs: "100%", sm: 500 },
            maxWidth: "100%",
            height: { xs: "auto", sm: 350 },
            m: { xs: 2, sm: 4 },
            borderRadius: 4,
            overflow: "hidden",
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          height: 70,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Optional: Add a logo/icon */}
      </Box>

      <DialogContent
        sx={{
          backgroundColor: theme.palette.background.default,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={4}
        >
          <Typography fontSize={26} fontWeight={600} textAlign="center">
            {label}
          </Typography>

          <Box display="flex" justifyContent="center" gap={6} width="100%">
            <ButtonComp
              variant="contained"
              height={40}
              width={140}
              onClick={confirmDelete}
              textTransform="none"
            >
              Yes
            </ButtonComp>
            <ButtonComp
              variant="contained"
              height={40}
              width={140}
              onClick={() => onClose()}
              textTransform="none"
            >
              No
            </ButtonComp>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
